module.exports = __webpack_public_path__ + "static/img/easy.561e74d4.svg";